import { defineStore } from 'pinia';

export interface Permissions {
    create_pur_invoice: boolean;
    create_pur_credit_note: boolean;
    create_payment: boolean;
}

interface OcrVerificationState {
    permissions: Permissions;
}

const META_URL = 'ocr/pur-invoice/metas';

export const useOcrVerificationStore = defineStore('ocrVerification', {
    state: (): OcrVerificationState => ({
        permissions: {
            create_pur_invoice: false,
            create_pur_credit_note: false,
            create_payment: false,
        },
    }),
    actions: {
        async loadMeta(): Promise<void> {
            const response = await ApiClient.get(META_URL);
            const data = response?.data;
            if (data && typeof data === 'object') {
                this.permissions = { ...this.permissions, ...(data as Partial<Permissions>) };
            }
        },
    },
});
